import { styled, keyframes } from 'styled-components';

import {
  colors,
  cssBreakpoints,
  fontWeights,
  gutterWidth,
  shadows,
  spacing,
} from '#/theme/theme';

const dialogEnter = keyframes`
  from {
    translate: 0 20%;
    opacity: 0;
  }
`;

const overlayFadeIn = keyframes`
  from {
    background: transparent;
  }
`;

export const FilterDialogOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 104;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 0.3);

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    animation: ${overlayFadeIn} var(--transition);
  }
`;

export const FilterDialogPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  background: ${colors.white};

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    animation: ${dialogEnter} var(--transition);
    max-width: 600px;
    height: auto;
    max-height: 80dvh;
    border: 1px solid ${colors.elementGrey};
    border-radius: 8px;
    overflow: hidden;
    box-shadow: ${shadows.highest};
  }
`;

export const FilterDialogHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${gutterWidth / 2}px;
  height: 60px;
  border-bottom: 1px solid ${colors.selectionGrey};
  flex-shrink: 0;
`;

export const FilterDialogTitle = styled.span`
  font-size: 18px;
  font-weight: ${fontWeights.semiBold};
  color: ${colors.brandBlue};
`;

export const FilterDialogBody = styled.div`
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: ${spacing[24]} ${gutterWidth / 2}px;
`;

export const FilterDialogFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[8]};
  padding: ${spacing[12]} ${gutterWidth / 2}px;
  box-shadow:
    rgb(0 0 0 / 0.04) 0 0 16px,
    rgb(0 0 0 / 0.07) 0 -2px 8px,
    rgb(0 0 0 / 0.1) 0 -1px 3px;
  flex-shrink: 0;
`;
